var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-container",on:{"click":_vm.onTypeClick}},[_c('div',{staticClass:"dropdown-text"},[_vm._v(" "+_vm._s(_vm.verifyText(_vm.verifyType))+" ")]),_c('img',{staticClass:"dropdown-icon",attrs:{"src":require("@/icons/dropdown.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }